// extracted by mini-css-extract-plugin
export default {"trigger":"newAnnouncementButton_trigger__BJN28"};